var map = {
	"./accepted_active.svg": 800,
	"./accepted_inactive.svg": 801,
	"./accepted_pass.svg": 802,
	"./booked_active.svg": 803,
	"./booked_inactive.svg": 804,
	"./booked_pass.svg": 805,
	"./confirmed_active.svg": 806,
	"./confirmed_inactive.svg": 807,
	"./confirmed_pass.svg": 808,
	"./dropoff_active.svg": 809,
	"./dropoff_inactive.svg": 810,
	"./dropoff_pass.svg": 811,
	"./loaded_active.svg": 812,
	"./loaded_inactive.svg": 813,
	"./loaded_pass.svg": 814,
	"./pickup_active.svg": 815,
	"./pickup_inactive.svg": 816,
	"./pickup_pass.svg": 817,
	"./pod_active.svg": 818,
	"./pod_inactive.svg": 819,
	"./pod_pass.svg": 820,
	"./unloaded_active.svg": 821,
	"./unloaded_inactive.svg": 822,
	"./unloaded_pass.svg": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;